// material-ui
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

interface DrawerHeaderStyledProps {
  open?: boolean;
}

const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })<DrawerHeaderStyledProps>(({ theme }) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: theme.spacing(0),
  variants: [
    {
      // Aberto: logo Boneside centralizado no header (nav abaixo segue à esquerda).
      props: ({ open }: DrawerHeaderStyledProps) => open,
      style: { justifyContent: 'center', paddingLeft: theme.spacing(0) }
    }
  ]
}));

export default DrawerHeaderStyled;
